module.exports = __webpack_public_path__ + "static/img/dmm_logo.92c7e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dmm_logo.png
// module id = TurC
// module chunks = 1